var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelLinkedinSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.657 3.94v7.74H.325V3.94zm6.616-.299c1.723 0 2.707 1.12 2.727 3.52v4.518H9.672v-4.16c0-1.066-.381-1.794-1.337-1.794-.729 0-1.163.49-1.354.964-.07.17-.121.404-.121.641v4.349H4.19v-.187c.004-.633.013-2.758.015-4.6v-1.01c0-.955-.005-1.707-.015-1.925h2.703v.995c.35-.54.978-1.31 2.379-1.31M1.493 0c.903 0 1.458.593 1.476 1.371 0 .763-.573 1.373-1.494 1.373H1.46C.573 2.744 0 2.134 0 1.37 0 .593.59 0 1.493 0"
})));
export default SvgChannelLinkedinSm;